/* eslint-disable no-alert */
import * as actionTypes from 'actions/actionTypes';
import { loanFormStepBack } from 'actions/loan';
import store from 'router/store';
import history from 'router/history';
import queryStringParser from 'utils/queryStringParser';

const queryParameters = queryStringParser.parseAndMakeKeysLowerCase(location.search);

export function mwLogout() {
  alert('logout');
  return {
    type: actionTypes.MW_LOGOUT,
  };
}

export function mwLogin() {
  alert('login');
  return {
    type: actionTypes.MW_LOGIN,
  };
}

export function mwResumeFlow() {
  alert('resume flow');
  return {
    type: actionTypes.MW_RESUME_FLOW,
  };
}

export function mwPinReset() {
  alert('pin reset');
  return {
    type: actionTypes.MW_PIN_RESET,
  };
}
export function mwPayInvoice() {
  alert('pay invoice');
  return {
    type: actionTypes.MW_PAY_INVOICE,
  };
}

export function mwSendPageStatus(status = '') {
  alert(status);
  return {
    type: actionTypes.MW_SEND_STATUS,
    data: status,
  };
}

export function mwGoBack() {
  alert('go back');
  return {
    type: actionTypes.MW_GO_BACK,
  };
}

export function deviceBackButtonClick() {
  const { authentication, loan } = store.getState();
  const { currentStep, steps } = loan;

  let isBackEnabled;

  const currentStepObject = steps[currentStep];
  const currentStepType = currentStepObject.type;

  switch (true) {
    case loan.isLoanSubmitting || loan.isContentLoading:
    case loan.isLoanSubmitted && COUNTRY === 'FI':
    case currentStepType === 'CUSTOMER_FI':
    case currentStepType === 'INCOME_FI':
    case currentStepType === 'PAYMENT_DAY':
    case currentStepType === 'PRODUCT' || currentStepType === 'SUBMIT':
    case loan.rejected !== null:
      isBackEnabled = false;
      break;
    default:
      isBackEnabled = true;
  }

  if (isBackEnabled && authentication.isAuthenticated) {
    store.dispatch(loanFormStepBack());
  }

  const { pathname } = history.getCurrentLocation();

  const isBackButtonVisibleQueryParam = (pathname.match(/^other-services\/?$/) || pathname.startsWith('register'))
    && queryParameters.displayback === 'true';

  if (pathname === 'credit-info/payment-details') {
    history.goBack();
  } else if (isBackButtonVisibleQueryParam) {
    store.dispatch(mwGoBack());
  } else if (pathname.startsWith('other-services')) {
    history.replace(`/other-services${location.search}`);
  }

  return {
    type: actionTypes.MW_BACK_BUTTON_CLICK,
  };
}

export function mwGoMainPage() {
  alert('open main');
  return {
    type: actionTypes.MW_GO_MAIN,
  };
}
